import { render } from "./Polygon.vue?vue&type=template&id=7ef03d58"
import script from "./Polygon.vue?vue&type=script&lang=js"
export * from "./Polygon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__